import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers, normalizeStyle as _normalizeStyle, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-1f9af6c4"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "image-cut-container" }
const _hoisted_2 = { class: "header-section" }
const _hoisted_3 = /*#__PURE__*/_createTextVNode(" Configuración de Recorte de Imagen - Punto de Monitorización: ")
const _hoisted_4 = { class: "highlight-text" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "card-header" }, [
  /*#__PURE__*/_createElementVNode("span", null, "Cargar Imagen Original")
], -1))
const _hoisted_6 = { class: "upload-actions" }
const _hoisted_7 = /*#__PURE__*/_createTextVNode("Subir desde equipo")
const _hoisted_8 = /*#__PURE__*/_createTextVNode(" Seleccionar de galería ")
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "card-header" }, [
  /*#__PURE__*/_createElementVNode("span", null, "Ajustes del Recorte")
], -1))
const _hoisted_10 = /*#__PURE__*/_createTextVNode("Restablecer valores")
const _hoisted_11 = { class: "image-workspace" }
const _hoisted_12 = {
  key: 0,
  class: "no-image-placeholder"
}
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "Por favor, cargue una imagen original para configurar el recorte", -1))
const _hoisted_14 = ["src"]
const _hoisted_15 = { class: "dimensions-badge" }
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "card-header" }, [
  /*#__PURE__*/_createElementVNode("span", null, "Vista Previa del Recorte")
], -1))
const _hoisted_17 = { class: "preview-container" }
const _hoisted_18 = { class: "preview-box" }
const _hoisted_19 = {
  key: 0,
  class: "placeholder-text"
}
const _hoisted_20 = ["src"]
const _hoisted_21 = { class: "actions-footer" }
const _hoisted_22 = /*#__PURE__*/_createTextVNode("Guardar Configuración")

import { ref, computed, watch } from "vue";
import { ElMessage } from "element-plus";
import { Picture } from "@element-plus/icons-vue";
import { getSamplingPointById } from "@/service/samplingpoint.service";
import type { SamplingPoint } from "@/types/samplingpoint.type";
import type { UploadFile } from "element-plus";
import {
  getImagesByDateIncremental,
  saveImageCropConfiguration,
  getImage,
} from "@/service/image.service";
import { useRoute } from "vue-router";
import { Station } from "@/types";
import galleryImageCutout from "@/components/processTracking/imageLabel/galleryImageCutout.component";
import { getCamerasConfigurationByStationId } from "@/service/cameraConfiguration.service";

interface CameraOption {
  code: string;
  name: string;
}

export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const route = useRoute();

// Refs
const galleryDialogVisible = ref<boolean>(false);
const sp = ref<SamplingPoint | null>(null);
const station = ref<Station | null>(null);
const imageUrl = ref<string>("");
const selectedGalleryImageId = ref<number>(0);
const rawFile = ref<File | null>(null);
const workspaceImgRef = ref<HTMLImageElement | null>(null);
const wrapperRef = ref<HTMLDivElement | null>(null);
const naturalDimensions = ref({ width: 0, height: 0 });
const cropSettings = ref({
  x: 120,
  y: 60,
  width: 568,
  height: 426,
});

const TARGET_ASPECT_RATIO = 568 / 426;

const minWidth = computed(() => {
  if (naturalDimensions.value.width > 0) {
    return Math.round(naturalDimensions.value.width / 4);
  }
  return 142;
});

const isDragging = ref(false);
const dragMode = ref<"move" | "top-left" | "top-right" | "bottom-left" | "bottom-right" | null>(
  null
);
const startMousePos = ref({ x: 0, y: 0 });
const startCropSettings = ref({ x: 0, y: 0, width: 0, height: 0 });
const expectedDimensions = ref<{ width: number; height: number } | null>(null);

const availableCameras = ref<CameraOption[]>([]);
const selectedCamera = ref<string>("");

const calculateProportionalHeight = () => {
  cropSettings.value.height = Math.round(cropSettings.value.width / TARGET_ASPECT_RATIO);
};

const handleImageUpload = (uploadFile: UploadFile) => {
  if (!uploadFile.raw) return;

  const tempUrl = URL.createObjectURL(uploadFile.raw);
  const imgToTest = new Image();

  imgToTest.onload = () => {
    const width = imgToTest.naturalWidth;
    const height = imgToTest.naturalHeight;

    if (expectedDimensions.value) {
      if (width !== expectedDimensions.value.width || height !== expectedDimensions.value.height) {
        ElMessage.error(
          `Resolución incorrecta. La imagen es de ${width}x${height} pero se requiere que sea de ${expectedDimensions.value.width}x${expectedDimensions.value.height}.`
        );
        URL.revokeObjectURL(tempUrl);
        return;
      }
    }

    rawFile.value = uploadFile.raw!;
    imageUrl.value = tempUrl;
  };

  imgToTest.onerror = () => {
    ElMessage.error("El archivo seleccionado no es una imagen válida.");
    URL.revokeObjectURL(tempUrl);
  };

  imgToTest.src = tempUrl;
};

const onImgLoaded = () => {
  if (workspaceImgRef.value) {
    naturalDimensions.value = {
      width: workspaceImgRef.value.naturalWidth,
      height: workspaceImgRef.value.naturalHeight,
    };

    cropSettings.value.width = minWidth.value;
    calculateProportionalHeight();

    if (cropSettings.value.x + cropSettings.value.width > naturalDimensions.value.width) {
      cropSettings.value.x = 0;
    }
    if (cropSettings.value.y + cropSettings.value.height > naturalDimensions.value.height) {
      cropSettings.value.y = 0;
    }
  }
};

// --- LOGICA DE ARRASTRE Y REDIMENSIÓN DIRECTA CON EL RATÓN ---
const initDrag = (event: MouseEvent, mode: typeof dragMode.value) => {
  if (!naturalDimensions.value.width || !wrapperRef.value) return;

  isDragging.value = true;
  dragMode.value = mode;
  startMousePos.value = { x: event.clientX, y: event.clientY };
  startCropSettings.value = { ...cropSettings.value };

  document.addEventListener("mousemove", handleDrag);
  document.addEventListener("mouseup", stopDrag);
};

const handleDrag = (event: MouseEvent) => {
  if (!isDragging.value || !wrapperRef.value || !naturalDimensions.value.width) return;

  const rect = wrapperRef.value.getBoundingClientRect();

  const pxToNaturalScale = naturalDimensions.value.width / rect.width;

  const deltaX = (event.clientX - startMousePos.value.x) * pxToNaturalScale;
  const deltaY = (event.clientY - startMousePos.value.y) * pxToNaturalScale;

  let newX = startCropSettings.value.x;
  let newY = startCropSettings.value.y;
  let newWidth = startCropSettings.value.width;

  if (dragMode.value === "move") {
    newX = Math.max(
      0,
      Math.min(
        startCropSettings.value.x + deltaX,
        naturalDimensions.value.width - startCropSettings.value.width
      )
    );
    newY = Math.max(
      0,
      Math.min(
        startCropSettings.value.y + deltaY,
        naturalDimensions.value.height - startCropSettings.value.height
      )
    );

    cropSettings.value.x = Math.round(newX);
    cropSettings.value.y = Math.round(newY);
  } else {
    const MIN_WIDTH = minWidth.value;

    if (dragMode.value === "bottom-right") {
      newWidth = Math.max(MIN_WIDTH, startCropSettings.value.width + deltaX);
      if (
        newX + newWidth <= naturalDimensions.value.width &&
        newY + newWidth / TARGET_ASPECT_RATIO <= naturalDimensions.value.height
      ) {
        cropSettings.value.width = Math.round(newWidth);
      }
    } else if (dragMode.value === "bottom-left") {
      const allowedDeltaX = Math.min(deltaX, startCropSettings.value.width - MIN_WIDTH);
      const potentialX = startCropSettings.value.x + allowedDeltaX;
      if (potentialX >= 0) {
        newWidth = startCropSettings.value.width - allowedDeltaX;
        if (newY + newWidth / TARGET_ASPECT_RATIO <= naturalDimensions.value.height) {
          cropSettings.value.x = Math.round(potentialX);
          cropSettings.value.width = Math.round(newWidth);
        }
      }
    } else if (dragMode.value === "top-right") {
      newWidth = Math.max(MIN_WIDTH, startCropSettings.value.width + deltaX);
      const newHeight = newWidth / TARGET_ASPECT_RATIO;
      const potentialY = startCropSettings.value.y + (startCropSettings.value.height - newHeight);
      if (newX + newWidth <= naturalDimensions.value.width && potentialY >= 0) {
        cropSettings.value.y = Math.round(potentialY);
        cropSettings.value.width = Math.round(newWidth);
      }
    } else if (dragMode.value === "top-left") {
      const allowedDeltaX = Math.min(deltaX, startCropSettings.value.width - MIN_WIDTH);
      const potentialX = startCropSettings.value.x + allowedDeltaX;
      newWidth = startCropSettings.value.width - allowedDeltaX;
      const newHeight = newWidth / TARGET_ASPECT_RATIO;
      const potentialY = startCropSettings.value.y + (startCropSettings.value.height - newHeight);

      if (potentialX >= 0 && potentialY >= 0) {
        cropSettings.value.x = Math.round(potentialX);
        cropSettings.value.y = Math.round(potentialY);
        cropSettings.value.width = Math.round(newWidth);
      }
    }
    calculateProportionalHeight();
  }
};

const stopDrag = () => {
  isDragging.value = false;
  dragMode.value = null;
  document.removeEventListener("mousemove", handleDrag);
  document.removeEventListener("mouseup", stopDrag);
};

const overlayStyle = computed(() => {
  if (!naturalDimensions.value.width || !naturalDimensions.value.height) return {};

  const leftPercent = (cropSettings.value.x / naturalDimensions.value.width) * 100;
  const topPercent = (cropSettings.value.y / naturalDimensions.value.height) * 100;
  const widthPercent = (cropSettings.value.width / naturalDimensions.value.width) * 100;
  const heightPercent = (cropSettings.value.height / naturalDimensions.value.height) * 100;

  return {
    left: `${leftPercent}%`,
    top: `${topPercent}%`,
    width: `${widthPercent}%`,
    height: `${heightPercent}%`,
  };
});

const previewWrapperStyle = computed(() => {
  return {
    width: "100%",
    height: "100%",
    position: "relative" as const,
    overflow: "hidden" as const,
  };
});

const previewImgStyle = computed(() => {
  if (
    !cropSettings.value.width ||
    !naturalDimensions.value.width ||
    !naturalDimensions.value.height
  )
    return {};

  const widthRatio = naturalDimensions.value.width / cropSettings.value.width;
  const heightRatio = naturalDimensions.value.height / cropSettings.value.height;

  const leftPercent = (cropSettings.value.x / naturalDimensions.value.width) * 100 * widthRatio;
  const topPercent = (cropSettings.value.y / naturalDimensions.value.height) * 100 * heightRatio;

  return {
    position: "absolute" as const,
    width: `${widthRatio * 100}%`,
    height: `${heightRatio * 100}%`,
    left: `-${leftPercent}%`,
    top: `-${topPercent}%`,
    objectFit: "fill" as const,
  };
});

const sp_id = computed(() => {
  return (route.query.samplingPoint as string) || "";
});

const loadData = async (id: string) => {
  try {
    sp.value = await getSamplingPointById(Number(id));
    station.value = sp.value?.station as Station;

    const camerasConfiguration = await getCamerasConfigurationByStationId(station.value.id || 0);

    if (Array.isArray(camerasConfiguration)) {
      availableCameras.value = camerasConfiguration.map((c: any) => ({
        code: c.camera.code,
        name: c.camera.name,
      }));

      if (availableCameras.value.length > 0) {
        selectedCamera.value = availableCameras.value[0].code;
      }
    }

    const data = await getImagesByDateIncremental(
      `${station.value.station}`,
      undefined,
      false,
      undefined,
      undefined,
      undefined,
      "ALL"
    );

    const newImages = Array.isArray(data) ? data : [];

    if (newImages.length > 0 && newImages[0].fileName) {
      try {
        const firstImgBlob = await getImage(newImages[0].fileName, false);
        const tempImg = new Image();

        tempImg.onload = () => {
          expectedDimensions.value = {
            width: tempImg.naturalWidth,
            height: tempImg.naturalHeight,
          };
        };
        tempImg.src = firstImgBlob as string;
      } catch (err) {
        console.warn("No se pudo cargar la imagen para determinar la resolución base.");
      }
    }

    calculateProportionalHeight();
  } catch (error) {
    // error
  }
};

const openGallery = () => {
  galleryDialogVisible.value = true;
};

const handleGalleryImageSelect = (imageData: { id: number; url: string; camera: string }) => {
  if (!imageData || !imageData.url) {
    ElMessage.error("No se pudo obtener la información de la imagen seleccionada.");
    return;
  }

  imageUrl.value = imageData.url;

  selectedGalleryImageId.value = imageData.id;

  galleryDialogVisible.value = false;

  selectedCamera.value = imageData.camera;

  ElMessage.success("Imagen de la galería cargada correctamente.");
};

const resetValues = () => {
  cropSettings.value = { x: 60, y: 100, width: 568, height: 426 };
  calculateProportionalHeight();
};

const saveConfiguration = async () => {
  if (!selectedCamera.value) {
    ElMessage.error("Debes seleccionar una cámara antes de guardar.");
    return;
  }

  if (
    cropSettings.value.x + cropSettings.value.width > naturalDimensions.value.width ||
    cropSettings.value.y + cropSettings.value.height > naturalDimensions.value.height
  ) {
    ElMessage.error("El área de recorte excede los límites reales de la imagen.");
    return;
  }

  try {
    await saveImageCropConfiguration({
      samplingPointId: Number(sp_id.value),
      stationId: (sp.value?.station as Station).id || null,
      camera: selectedCamera.value,
      x: Number(cropSettings.value.x),
      y: Number(cropSettings.value.y),
      width: Number(cropSettings.value.width),
      height: Number(cropSettings.value.height),
      imagePath:
        selectedGalleryImageId.value !== 0
          ? selectedGalleryImageId.value.toString()
          : imageUrl.value,
    });

    ElMessage.success("Configuración de recorte guardada exitosamente.");
  } catch (error) {
    ElMessage.error("Error al intentar guardar la configuración en el servidor.");
  }
};

watch(
  sp_id,
  (newId) => {
    if (newId) {
      imageUrl.value = "";
      selectedGalleryImageId.value = 0;
      rawFile.value = null;
      naturalDimensions.value = { width: 0, height: 0 };

      resetValues();

      loadData(newId);
    }
  },
  { immediate: true }
);

return (_ctx: any,_cache: any) => {
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_upload = _resolveComponent("el-upload")!
  const _component_el_dialog = _resolveComponent("el-dialog")!
  const _component_el_card = _resolveComponent("el-card")!
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_input_number = _resolveComponent("el-input-number")!
  const _component_el_form = _resolveComponent("el-form")!
  const _component_el_col = _resolveComponent("el-col")!
  const _component_el_icon = _resolveComponent("el-icon")!
  const _component_el_row = _resolveComponent("el-row")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("h2", null, [
        _hoisted_3,
        _createElementVNode("span", _hoisted_4, _toDisplayString(sp.value?.name), 1)
      ])
    ]),
    _createVNode(_component_el_row, { gutter: 20 }, {
      default: _withCtx(() => [
        _createVNode(_component_el_col, {
          xs: 24,
          sm: 8,
          md: 6
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_card, {
              class: "box-card",
              shadow: "never"
            }, {
              header: _withCtx(() => [
                _hoisted_5
              ]),
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_6, [
                  _createVNode(_component_el_upload, {
                    action: "#",
                    "auto-upload": false,
                    "show-file-list": false,
                    accept: "image/*",
                    "on-change": handleImageUpload,
                    class: "w-full"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_button, {
                        type: "primary",
                        class: "w-full",
                        icon: "Upload"
                      }, {
                        default: _withCtx(() => [
                          _hoisted_7
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_el_button, {
                    type: "info",
                    plain: "",
                    class: "w-full",
                    icon: "Picture",
                    style: {"margin-left":"0","margin-top":"10px"},
                    onClick: openGallery
                  }, {
                    default: _withCtx(() => [
                      _hoisted_8
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_el_dialog, {
                    modelValue: galleryDialogVisible.value,
                    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((galleryDialogVisible).value = $event)),
                    title: "Seleccionar Imagen de la Galería",
                    width: "60%",
                    "destroy-on-close": ""
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_unref(galleryImageCutout), {
                        "sampling-point-id": Number(_unref(sp_id)),
                        "station-id": station.value?.station,
                        onSelected: handleGalleryImageSelect,
                        onCancel: _cache[0] || (_cache[0] = ($event: any) => (galleryDialogVisible.value = false))
                      }, null, 8, ["sampling-point-id", "station-id"])
                    ]),
                    _: 1
                  }, 8, ["modelValue"])
                ])
              ]),
              _: 1
            }),
            _createVNode(_component_el_card, {
              class: "box-card m-top-20",
              shadow: "never"
            }, {
              header: _withCtx(() => [
                _hoisted_9
              ]),
              default: _withCtx(() => [
                _createVNode(_component_el_form, { "label-position": "top" }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_form_item, { label: "Cámara" }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_select, {
                          modelValue: selectedCamera.value,
                          "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((selectedCamera).value = $event)),
                          placeholder: "Seleccione una cámara",
                          class: "w-full"
                        }, {
                          default: _withCtx(() => [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(availableCameras.value, (cam) => {
                              return (_openBlock(), _createBlock(_component_el_option, {
                                key: cam.code,
                                label: cam.name,
                                value: cam.code
                              }, null, 8, ["label", "value"]))
                            }), 128))
                          ]),
                          _: 1
                        }, 8, ["modelValue"])
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_el_form_item, { label: "Punto Inicial X (px)" }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_input_number, {
                          modelValue: cropSettings.value.x,
                          "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((cropSettings.value.x) = $event)),
                          min: 0,
                          max: naturalDimensions.value.width - cropSettings.value.width,
                          class: "w-full",
                          "controls-position": "right"
                        }, null, 8, ["modelValue", "max"])
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_el_form_item, { label: "Punto Inicial Y (px)" }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_input_number, {
                          modelValue: cropSettings.value.y,
                          "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((cropSettings.value.y) = $event)),
                          min: 0,
                          max: naturalDimensions.value.height - cropSettings.value.height,
                          class: "w-full",
                          "controls-position": "right"
                        }, null, 8, ["modelValue", "max"])
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_el_form_item, { label: "Ancho por defecto (px)" }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_input_number, {
                          modelValue: cropSettings.value.width,
                          "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((cropSettings.value.width) = $event)),
                          min: _unref(minWidth),
                          max: naturalDimensions.value.width - cropSettings.value.x,
                          class: "w-full",
                          "controls-position": "right",
                          onInput: calculateProportionalHeight
                        }, null, 8, ["modelValue", "min", "max"])
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_el_form_item, { label: "Alto por defecto (px)" }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_input_number, {
                          modelValue: cropSettings.value.height,
                          "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((cropSettings.value.height) = $event)),
                          min: 10,
                          class: "w-full",
                          "controls-position": "right",
                          disabled: ""
                        }, null, 8, ["modelValue"])
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_el_button, {
                      class: "w-full m-top-10",
                      onClick: resetValues
                    }, {
                      default: _withCtx(() => [
                        _hoisted_10
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          _: 1
        }),
        _createVNode(_component_el_col, {
          xs: 24,
          sm: 16,
          md: 12
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_card, {
              class: "box-card workspace-card",
              shadow: "never"
            }, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_11, [
                  (!imageUrl.value)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
                        _createVNode(_component_el_icon, { size: 40 }, {
                          default: _withCtx(() => [
                            _createVNode(_unref(Picture))
                          ]),
                          _: 1
                        }),
                        _hoisted_13
                      ]))
                    : (_openBlock(), _createElementBlock("div", {
                        key: 1,
                        class: "image-relative-wrapper",
                        ref_key: "wrapperRef",
                        ref: wrapperRef
                      }, [
                        _createElementVNode("img", {
                          src: imageUrl.value,
                          alt: "Original",
                          class: "responsive-img",
                          ref_key: "workspaceImgRef",
                          ref: workspaceImgRef,
                          onLoad: onImgLoaded,
                          style: {"user-select":"none","-webkit-user-drag":"none"}
                        }, null, 40, _hoisted_14),
                        _createElementVNode("div", {
                          class: "bounding-box-overlay",
                          style: _normalizeStyle(_unref(overlayStyle)),
                          onMousedown: _cache[11] || (_cache[11] = _withModifiers(($event: any) => (initDrag($event, 'move')), ["stop"]))
                        }, [
                          _createElementVNode("div", {
                            class: "resize-handle top-left",
                            onMousedown: _cache[7] || (_cache[7] = _withModifiers(($event: any) => (initDrag($event, 'top-left')), ["stop"]))
                          }, null, 32),
                          _createElementVNode("div", {
                            class: "resize-handle top-right",
                            onMousedown: _cache[8] || (_cache[8] = _withModifiers(($event: any) => (initDrag($event, 'top-right')), ["stop"]))
                          }, null, 32),
                          _createElementVNode("div", {
                            class: "resize-handle bottom-left",
                            onMousedown: _cache[9] || (_cache[9] = _withModifiers(($event: any) => (initDrag($event, 'bottom-left')), ["stop"]))
                          }, null, 32),
                          _createElementVNode("div", {
                            class: "resize-handle bottom-right",
                            onMousedown: _cache[10] || (_cache[10] = _withModifiers(($event: any) => (initDrag($event, 'bottom-right')), ["stop"]))
                          }, null, 32),
                          _createElementVNode("span", _hoisted_15, _toDisplayString(cropSettings.value.width) + " x " + _toDisplayString(cropSettings.value.height), 1)
                        ], 36)
                      ], 512))
                ])
              ]),
              _: 1
            })
          ]),
          _: 1
        }),
        _createVNode(_component_el_col, {
          xs: 24,
          sm: 24,
          md: 6
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_card, {
              class: "box-card preview-card",
              shadow: "never"
            }, {
              header: _withCtx(() => [
                _hoisted_16
              ]),
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_17, [
                  _createElementVNode("div", _hoisted_18, [
                    (!imageUrl.value)
                      ? (_openBlock(), _createElementBlock("p", _hoisted_19, "Sin previsualización"))
                      : (_openBlock(), _createElementBlock("div", {
                          key: 1,
                          class: "preview-cropped-wrapper",
                          style: _normalizeStyle(_unref(previewWrapperStyle))
                        }, [
                          _createElementVNode("img", {
                            src: imageUrl.value,
                            alt: "Preview",
                            style: _normalizeStyle(_unref(previewImgStyle))
                          }, null, 12, _hoisted_20)
                        ], 4))
                  ])
                ])
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    }),
    _createElementVNode("div", _hoisted_21, [
      _createVNode(_component_el_button, {
        type: "primary",
        icon: "Check",
        disabled: !imageUrl.value,
        onClick: saveConfiguration
      }, {
        default: _withCtx(() => [
          _hoisted_22
        ]),
        _: 1
      }, 8, ["disabled"])
    ])
  ]))
}
}

})